import React from 'react'

import { type ConnectionStatus } from './services/connectionStatus'

const MESSAGES: Record<Exclude<ConnectionStatus, 'ok'>, string> = {
  localSlow: '⚠️ Your connection looks slow — moves may be delayed',
  opponentOffline: '🔌 Opponent appears to be offline',
}

export function ConnectionBanner({ status }: { status: ConnectionStatus }) {
  if (status === 'ok') {
    return null
  }
  return (
    <div
      className={`connection-banner ${status}`}
      role="status"
      aria-live="polite"
    >
      {MESSAGES[status]}
    </div>
  )
}
